<div class="card panel-flat-color secondary-panel">
    <div
        class="panel-flat-header"
        style="cursor: pointer"
        (click)="expandOrCollapse()"
        [ngClass]="{ 'disable-pointer-events': !hasViewPermission }"
    >
        <panel-chevron [showBody]="showBody"></panel-chevron>
        <h3>Litigation Referrals</h3>
    </div>
    @if (showBody) {
        <div class="card-body" style="padding-top: 0">
            @if (isLoading) {
                <div class="text-center" style="margin: 25px 0">
                    <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
                </div>
            }
            @if (!isLoading) {
                <div class="table-container">
                    <table class="table table-striped table-hover" style="table-layout: fixed">
                        <thead>
                            <tr>
                                <th>RLS Due Date</th>
                                <th>Referral ID</th>
                                <th>Site Name</th>
                                <th>Site Number</th>
                                <th>State</th>
                                <th>Assessor Abbr</th>
                                <th>Tax Year</th>
                                <th>Appeal Level</th>
                                <th>Number of Appeals</th>
                                <th>Status</th>
                                <th style="width: 40px"></th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (referral of referrals; track referral.litigationReferralId) {
                                <tr
                                    (mouseenter)="hoveredReferralId = referral.litigationReferralId"
                                    (mouseleave)="hoveredReferralId = undefined"
                                >
                                    <td>
                                        <weissman-datetime
                                            [inputDate]="referral.rlsDueDate"
                                            [readOnly]="true"
                                            [dateOnly]="true"
                                        ></weissman-datetime>
                                    </td>
                                    <td>
                                        <a
                                            anchor-route
                                            [sref]="{
                                                target: 'litigationReferal',
                                                options: { referralId: referral.litigationReferralId },
                                            }"
                                        >
                                            {{ referral.matterId }}
                                        </a>
                                    </td>
                                    <td>{{ referral.siteName }}</td>
                                    <td>{{ referral.siteNumber }}</td>
                                    <td>{{ referral.state }}</td>
                                    <td>{{ referral.assessorName }}</td>
                                    <td>{{ referral.taxYear }}</td>
                                    <td>{{ referral.appealLevel }}</td>
                                    <td>{{ referral.numberOfAppeals }}</td>
                                    <td>
                                        <a
                                            style="cursor: pointer"
                                            (click)="launchTaskModal($event, referral.litigationReferralId)"
                                        >
                                            {{ referral.status }}
                                        </a>
                                    </td>
                                    <td style="width: 40px">
                                        <button
                                            class="ace-btn has-icon btn-primary btn-danger"
                                            [style.visibility]="
                                                hoveredReferralId === referral.litigationReferralId
                                                    ? 'visible'
                                                    : 'hidden'
                                            "
                                            style="margin: 0"
                                            (click)="deleteReferral(referral.litigationReferralId)"
                                            tooltip="Delete Referral"
                                        >
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                    @if (siteId && eligibleAppealCount > 0) {
                        <div style="display: flex; margin-top: 20px; justify-content: end">
                            <button class="ace-btn btn-primary" (click)="createReferral()">
                                Create {{ eligibleAppealCount }} Litigation Referral Appeal Task(s)
                            </button>
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
